import React from "react";

import { Table, SortState } from "@packages/ds";
import { useIntl } from "react-intl";

import { capitalize } from "Libs/utils";

import { FunctionSort } from "./types";

type Props = {
  sort?: SortState<FunctionSort>;
  setSort?: (key: keyof FunctionSort) => void;
};

const FlamebearerTableHead = ({ sort, setSort }: Props) => {
  const intl = useIntl();

  return (
    <Table.Thead>
      <Table.Th
        width="calc(100% - 180px)"
        onSortChanged={() => setSort?.("call")}
        isSortActive={sort?.key === "call"}
        sortDirection={sort?.direction}
      >
        {capitalize(
          intl.formatMessage({ id: "conprof.flamebearer.table.call" })
        )}
      </Table.Th>
      <Table.Th
        width="90px"
        onSortChanged={() => setSort?.("exclusive")}
        isSortActive={sort?.key === "exclusive"}
        sortDirection={sort?.direction}
      >
        {capitalize(
          intl.formatMessage({ id: "conprof.flamebearer.table.exclusive" })
        )}
      </Table.Th>
      <Table.Th
        width="90px"
        onSortChanged={() => setSort?.("inclusive")}
        isSortActive={sort?.key === "inclusive"}
        sortDirection={sort?.direction}
      >
        {capitalize(
          intl.formatMessage({ id: "conprof.flamebearer.table.inclusive" })
        )}
      </Table.Th>
    </Table.Thead>
  );
};

export default FlamebearerTableHead;
